export const EXCHANGE_WHEELS = 'WHEELS';
export const EXCHANGE_TIRES = 'TIRES';

/**
 * Replaced 'TIRES' or 'WHEELS' by 'Tires' or 'Wheels'
 */
export function getCamelCaseType(type) {
  return type.toLowerCase().replace(/(.)(.*)/g, ($1, $2, $3) => $2.toUpperCase() + $3);
}





// WEBPACK FOOTER //
// ./src/components/wheelsexchange/WheelsExchangeUtils.js